import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { PrivacyAgreementService } from './../../../core/services/privacy-agreement.service';
import { LoginService } from 'src/app/core/services/login.service';
import { AuthorizationProperties } from './../../../authentication/auth-info';
import { Component, OnInit } from '@angular/core';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { StepperOrientation } from '@angular/material/stepper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerService } from 'src/app/core/services/customer.service';
import { AdministrativeInfoContainer } from './../../../model/AdministrativeInfo';
import { Subscription } from 'rxjs';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ActivatedRoute, Params } from '@angular/router';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { ProductService } from 'src/app/core/services/product.service';
import { IndustryModuleCode, IndustryProductID, ProductCode } from 'src/app/model/industry';
import { Mode } from 'src/app/model/subscription';
import { MagoCloudService } from 'src/app/core/services/mago-cloud.service';
import { RolesService } from 'src/app/core/services/roles.service';
import { RolesWeight } from 'src/app/authentication/auth-helpers';
import { AccountRole } from 'src/app/model/account-role';
import { SubscriptionTokenMode } from 'src/app/model/configuration';
import { InstSnapVersInfo } from 'src/app/model/instance';
import { CountryService } from 'src/app/core/services/country.service';

@Component({
    selector: 'ms-magocloud-stepper',
    templateUrl: './magocloud-stepper.component.html',
    styleUrls: ['./magocloud-stepper.component.scss'],
})
export class MagocloudStepperComponent implements OnInit {
    stepperOrientation: Observable<StepperOrientation>;
    privacyNotSelected: boolean = true;
    authorizationProperties: AuthorizationProperties;
    authorizationStored;
    accountRoles: Array<AccountRole>;
    cmsObj: CmsObject[] = [];
    selectedSnapshotID: string;
    public instanceKey = '';
    public subTokenModeList: SubscriptionTokenMode[] = [];
    public countrySelectedDescri: string = '';
    public selectedNrUsersValue: string = '';
    public nextString = '';
    public backString = '';
    public minCal: number;
    public isExcellencePartner;
    public administrativeInfo: Subscription;
    public subSelectedDescri: string = '';
    public functLoaded: boolean = false;
    public queryParams: Params;
    public industry: string;
    public subscriptionKey = '';
    public subscriptionSelected = '';
    public language: string;
    public selectedInstanceKey: string;
    public showallOptions = false;
    public subTypeSelectedDescri = '';
    public subTypeSelected = 'none';
    public instanceselectedDescri = '';
    public smallScreen: boolean = false;
    constructor(
        private variable: TranslatedVariables,
        public magocloudService: MagoCloudService,
        private loginService: LoginService,
        private breakpointObserver: BreakpointObserver,
        private customerService: CustomerService,
        private cmsService: CmsService,
        public magocloudLoading: LoadingService,
        public privacyAgreementService: PrivacyAgreementService,
        public configurationService: ConfigurationService,
        private activatedRoute: ActivatedRoute,
        public storeRoleService: StoreRolesService,
        private serviceUtilsService: ServiceUtilsService,
        public workFlow: WorkFlowService,
        private productService: ProductService,
        private rolesService: RolesService,
        public workflow: WorkFlowService,
        private countryService: CountryService
    ) {
        this.productService.productRelease = '';
        this.magocloudService.edition = 'pro';
        this.stepperOrientation = breakpointObserver
            .observe('(min-width: 1600px)')
            .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));
    }

    async ngOnInit() {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.subscriptionKey = params.subKey ? atob(params.subKey) : '';
        });
        await this.getCmsObj();
        this.functLoaded = false;
        this.magocloudLoading.setLoading(this.functLoaded);
        this.getTranslations();
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        await this.checkRoles();
        this.administrativeInfo = this.customerService.companyInfo$.subscribe((companyInfo) => {
            if (!companyInfo) return;
            this.isExcellencePartner =
                AdministrativeInfoContainer.isPlatinumPartner(this.customerService.ListOfMandati, ProductCode.MAGOCLD) ||
                AdministrativeInfoContainer.isPlatinumPartner(this.customerService.ListOfMandati, ProductCode.MAGOWEB);
        });
        this.functLoaded = true;
        this.magocloudLoading.setLoading(this.functLoaded);
        this.magocloudService.isModifyStatus = this.subscriptionKey != undefined && this.subscriptionKey.length > 0;
        if (this.magocloudService.isModifyStatus) await this.getFunctionalities();
        this.countryService.countrySelected = this.magocloudService?.countryValue;
        this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
            this.smallScreen = result.matches;
        });
    }

    public async checkRoles() {
        this.rolesService.refreshRoles(this.authorizationProperties.accountName);
        //controllo i ruoli, per come sono nel token.
        // this.rolesService.refreshRoles(this.authorizationProperties.accountName);
        let isDevOps = this.rolesService.checkRolesMin(RolesWeight.DEVOPS);
        if (isDevOps) {
            this.showallOptions = true; //il devpops vede sempre tutte le tendine
            return;
        }

        this.accountRoles = this.authorizationProperties.roles as AccountRole[];
        this.showallOptions = !this.subscriptionKey
            ? this.storeRoleService.IsInternal // vedo tutte le tendine se sono internal e non c'è la SubKey
            : this.storeRoleService.IsInternal && //se ho la SubKey devo avere il ruolo internal ed essere useradmin per quella subscription
              this.accountRoles.some((r) => r.Weight === RolesWeight.USERADMIN && r.EntityKey === this.subscriptionKey);
    }

    selectedDescri(countrySelectedDescri: string) {
        this.countrySelectedDescri = countrySelectedDescri;
        this.magocloudService.countryDescri = this.countrySelectedDescri;
    }

    subSelected(subSelectedDescri: string) {
        this.subSelectedDescri = subSelectedDescri;
    }
    async selectedValue(countrySelectedValue: string) {
        this.magocloudService.countryValue = countrySelectedValue;
        this.magocloudService.countryDescri = await this.serviceUtilsService.getCountryDescription(countrySelectedValue);
        if (this.magocloudService.currIndustryPurchInfo) this.magocloudService.currIndustryPurchInfo.Country = countrySelectedValue;
        await this.getFunctionalities();
    }

    private getTranslations() {
        this.nextString = this.variable.commonsNext;
        this.backString = this.variable.commonsBack;
    }

    public async getFunctionalities() {
        this.functLoaded = false;
        this.magocloudLoading.setLoading(this.functLoaded);
        await this.getSubscriptionTokeModeList();
        //e una internal o una nfs
        if (this.subscriptionKey != undefined && this.subscriptionKey.length > 0) {
            await this.magocloudService.loadInternalIndustryInfo(this.subscriptionKey, this.authorizationProperties.accountName);
            this.subTypeSelected = this.subTokenModeList.find((x) => x.Name == this.magocloudService.subTypeSelected)?.Value;
            this.instanceKey = this.magocloudService.instanceKey;
            if (!this.magocloudService.subscriptionNfs) {
                await this.magocloudService.getInstancesList(this.subTypeSelected, this.magocloudService.moduleCode);
                this.magocloudService.getSnapshotFromInstancesList(this.instanceKey);
            }
            this.selectedSnapshotID = this.magocloudService.selectedSnapshotID;
        } else {
            //è nuova
            //valorizzo la release di prodotto
            if (this.productService || this.productService.resellerCode || this.productService.resellerCode.length == 0) {
                this.productService.resellerCode = this.customerService?.companyInfo?.CompanyCode;
            }
            await this.productService.setProductRelease(
                IndustryProductID.MC,
                Mode.rtm.toString(),
                this.magocloudService.countryValue, //mi serve qui la country del reseller
                '',
                this.magocloudService.moduleCode,
                this.storeRoleService.IsInternal ? '1' : '0',
                ''
            );
            await this.magocloudService.loadIndustryStruct(this.authorizationProperties.accountName, this.productService.productRelease);
        }
        this.magocloudService.setCALFeature();
        this.magocloudService.expandSummary = true;
        //carico le descrizioni e i titoli delle feature dal db
        await this.cmsService.getFeatureDataSheets();
        this.functLoaded = true;
        this.magocloudLoading.setLoading(this.functLoaded);
    }
    public async updateConfiguration() {}

    async onModeChanged() {
        if (this.subTypeSelected == 'none') {
            this.workflow.showMessage(this.variable.message_1, '');
            return;
        }
        this.subTypeSelectedDescri = this.subTokenModeList.find((x) => x.Value == this.subTypeSelected).Name;
        this.magocloudService.subTypeSelected = Mode[this.subTypeSelected].toString();
        this.magocloudService.currIndustryPurchInfo.SubscriptionMode = this.subTypeSelected.toString();
        this.functLoaded = false;
        this.magocloudLoading.setLoading(!this.functLoaded);
        await this.magocloudService.getInstancesList(this.subTypeSelected, this.magocloudService.moduleCode);
        this.functLoaded = true;
        this.magocloudLoading.setLoading(!this.functLoaded);
    }
    onInstanceKeyChanged() {
        if (this.instanceKey == 'none') {
            this.workflow.showMessage(this.variable.message_4, '');
            return;
        }
        let instance: InstSnapVersInfo = this.magocloudService.instanceList.find((x) => x.InstanceKey == this.instanceKey);
        this.instanceselectedDescri = instance ? instance.Description : 'nessuna istanza trovata';
        this.magocloudService.instanceKey = this.instanceKey;
        this.magocloudService.currIndustryPurchInfo.instanceKey = this.instanceKey;
        this.magocloudService.getSnapshotFromInstancesList(this.instanceKey);
        this.selectedSnapshotID = this.magocloudService.defaultSnapshot.SnapshotId;
        this.magocloudService.selectedSnapshotID = this.selectedSnapshotID;
    }
    public setSnapshotValue(selectedSnapshotID: string) {
        this.selectedSnapshotID = selectedSnapshotID;
        this.magocloudService.selectedSnapshotID = selectedSnapshotID;
    }

    async getSubscriptionTokeModeList() {
        let data: SubscriptionTokenMode[] = await this.configurationService.getAvailableSubscriptionTokenMode(
            true,
            this.authorizationProperties.accountName
        );
        if (data === null || data === undefined) {
            this.workflow.showMessage(this.variable.messageTitle_1, this.variable.messageSubTitle_1);
            return;
        }

        this.subTokenModeList = data;
        if (this.subTokenModeList.length == 0) {
            this.workflow.showMessage(this.variable.popupTitle, this.variable.messageSubTitle_2);
        }
    }
    public setCountryDisabled() {
        return (
            !this.magocloudService.countryValue ||
            this.magocloudService.countryValue.length == 0 ||
            this.magocloudService.countryValue == 'none'
        );
    }

    public setTipologyDisabled() {
        return (
            //TODO PAOLA
            false
        );
    }
    async getCmsObj() {
        this.language = this.workFlow.getLanguageForCms();
    }
    public async onEditionChangeEvent(editionCode: string) {
        this.magocloudService.edition = editionCode;
        await this.getFunctionalities();
    }
    public enableButton() {
        if (this.storeRoleService.IsInternal) this.magocloudService.totalCalFullNr = 1;
    }
}
